<app-reusable-table [list]="mastersuiteList" [collectionSize]="collectionSize" [tableName]="'Mastersuite'"
  [tableHead]="tableHead" (deleteSelected)="deleteMultipleMasterSuites($event)">
  <form [formGroup]="masterSuiteSearchForm" (ngSubmit)="pagination()" class="search-form row align-items-center">
    <div class="form-group input-with-addon col-4">
      <input type="text" id="keyword" class="form-control form-control-sm" placeholder="Search Keyword"
        formControlName="keyword">
    </div>
    <div class="form-group col-4">
      <ng-select [items]="myProjectsList" bindLabel="name" bindValue="id" placeholder="Select Project(s)"
        [searchable]="true" [multiple]="true" formControlName="projectIds">
        <ng-template ng-option-tmp let-item="item">
          <div title="{{item.name}}" class="text-truncate">{{item.name}}</div>
        </ng-template>
      </ng-select>
    </div>
    <div class="form-group col-4">
      <input type="text" id="locator-name" class="form-control form-control-sm" formControlName="updatedBy" placeholder="Search Updated By" />
    </div>
    <div class="form-group col-4">
      <input type="text" id="locator-name" class="form-control form-control-sm" formControlName="createdBy" placeholder="Search Created By" />
    </div>
    <div class="form-group col-4">
      <div style="display: flex;">
        <ng-select class="custom-style" id="locator-component" formControlName="sortBy" [items]="masterSuiteSortList" bindLabel="name" bindValue="id" placeholder="Select Sort Option" [clearable]="false" [searchable]="true" style="width: 95%;">
        </ng-select>
        <i class="fas fa-sort-amount-up-alt" style="font-size: large; margin: 5px 5px;" *ngIf="masterSuiteSortOrder === 'ASC'" ngbTooltip="Change the sort direction" (click)="updateSortOrder('DESC')"></i>
        <i class="fas fa-sort-amount-down-alt" style="font-size: large; margin: 5px 5px;" *ngIf="masterSuiteSortOrder === 'DESC'" ngbTooltip="Change the sort direction" (click)="updateSortOrder('ASC')"></i>
      </div>
    </div>
    <div class="align-items-center d-flex mb-2 ml-1 justify-content-around">
      <div class="form-check form-check-inline mb-2">
        <input class="form-check-input" type="checkbox" formControlName="parallelRun" id="parallel-run">
        <label class="form-check-label" for="parallel-run">Parallel Run</label>
      </div>
      <button type="submit" class="btn search-btn btn-primary btn-sm mb-2" name="button">Search</button>
      <button type="submit" (click)="clearSearchFilter()" class="clear-filter btn btn-warning ml-2 btn-sm mb-2"
        name="button">Clear</button>
    </div>
  </form>
  <tr tableContent *ngFor="let item of mastersuiteList; let index = index" class="clickable">
    <td width="3%" class="no-ellipsis">
      <input type="checkbox" [(ngModel)]="item.selected" [disabled]="!user.superAdmin && (item.project.role === 'Viewer' || item.project.role === 'Tester')" (click)="optionToggledMasterSuite(index)" />
    </td>
    <td width="20%" title="{{item.name}}">
      <i class="fas fa-award text-success" ngbTooltip="Certified" *ngIf="item.certified"></i>
      <a [routerLink]="['/mastersuite', item.id]" class="simple"> {{item.name}}</a>
    </td>
    <td width="20%" [routerLink]="['/mastersuite', item.id]">{{item.project.name}}</td>
    <td [routerLink]="['/mastersuite', item.id]">
      <i class="far fa-check-circle text-success" *ngIf="item.parallelRun"></i>
      <i class="far fa-times-circle text-danger" *ngIf="!item.parallelRun"></i>
    </td>
    <td width="18%" title="Created On : {{(item?.createdOn | localDate )}}" [routerLink]="['/mastersuite', item.id]">{{ (item?.updatedOn | localDate ) || "NA" }}</td>
    <td class="text-truncate" title="Created By : {{item?.createdBy?.displayName}}" [routerLink]="['/mastersuite', item.id]">{{ item?.updatedBy?.displayName}}</td>
    <td width="10%">
      <div class="action-buttons">
        <button class="btn btn-sm btn-icon" [ngClass]="(user.superAdmin || !(item.project.role === 'Viewer' || item.project.role === 'Tester')) ? '' : 'disabled-class'" [routerLink]="['/mastersuite', item.id, 'edit']" title="Edit Mastersuite"><i class="fas fa-edit"></i></button>
        <button class="btn btn-sm btn-icon text-danger" [ngClass]="(user.superAdmin || !(item.project.role === 'Viewer' || item.project.role === 'Tester')) ? '' : 'disabled-class'" title="Delete Mastersuite" (click)="deleteMasterSuite(item)"><i class="fas fa-trash"></i></button>
      </div>
    </td>
  </tr>
</app-reusable-table>